import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },
  '& .Mui-focused': {
    borderColor: '#673ab7',
  },
  '& .MuiFilledInput-root.Mui-focused': {
    border: '1px solid #673ab7',
  },
}));

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'PinCode', label: 'Pincode', minWidth: 170 },
  { id: 'AreaName', label: 'Area', minWidth: 100 },
  { id: 'AreaAbrv', label: 'ShortName', minWidth: 100 },
  { id: 'CityName', label: 'City', minWidth: 170 },
  { id: 'StateName', label: 'State', minWidth: 170 }
];

const Pincode = () => {
  
  const [formData, setFormData] = useState({
    PinCode: '',
    AreaName: '',
    CityName: '',
    AreaAbrv: '',
    StateName: ''
  });

  // const permissions = useModulePermissions("Pincode Master");

  const [error, setError] = useState({
    pinCode: false,
    areaName: false,
    city: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const location = useLocation();
  const [currentPinId, setCurrentPinId] = useState(null);
  const [mode, setMode] = useState('view');
  const [lastInsertedPinId, setLastInsertedPinId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const UserId = sessionStorage.getItem('UserId')
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const pinCodeRef = useRef(null);
  const areaNameRef = useRef(null);
  const cityRef = useRef(null);
  const areaAbrvRef = useRef(null);
  const stateRef = useRef(null);


  useEffect(() => {
    if (location.state && location.state.PinId) {
      setCurrentPinId(location.state.PinId);
      fetchPincodeData(location.state.PinId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchPincodeData = async (id, flag) => {
    
    try {
      const response = await axios.post(`pincodeMst/RetrivepincodeMst`, {
        PinId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const pincodeData = response.data.Data[0];
        setFormData({
          PinCode: pincodeData.PinCode,
          AreaName: pincodeData.AreaName,
          CityName: pincodeData.CityID.toString(),
          AreaAbrv: pincodeData.AreaAbrv,
          StateName: pincodeData.StateId.toString()
        });
        setStatus(pincodeData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentPinId(pincodeData.PinId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch pincode data');
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error('Error fetching pincode data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('pincodeMst/getAllpincodeMstDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  const handlePrevious = async () => {
    if (currentPinId && currentPinId > 1) {
      await fetchPincodeData(currentPinId, "P");
    }
  };

  const handleNext = async () => {
    if (currentPinId) {
      await fetchPincodeData(currentPinId, "N");
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.post(`CityMst/getstatedrp`);
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setStates(response.data.Data);
        } else {
          toast.error("Failed to fetch StateId");
        }
      } catch (error) {
        console.error("Error fetching StateId:", error);
        toast.error("Error fetching StateId. Please try again.");
      }
    };

    fetchStates();
  }, []);

  useEffect(() => {
    const fetchCities = async (id) => {
      try {
        const response = await axios.post(
          `cityMst/getStatewiseCitydrp`,
          {
            StateId: id,
          }
        );
        if (
          response.data.Status === 0 &&
          response.data.responseStatusCode === 1
        ) {
          setCities(response.data.Data);
        } else {
          toast.error("Failed to fetch Cities");
        }
      } catch (error) {
        toast.error("Error fetching Cities. Please try again.");
      }
    };

    if (formData.StateName) {
      fetchCities(formData.StateName);
    }
  }, [formData.StateName]);

  const handleInputChange = (event) => {
    const { name, value } = event.target; 
  
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));


    if (name === 'Pincode') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'Pincode' && value !== '') {
      setTimeout(() => {
        stateRef.current.focus();
      }, 100000);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === stateRef.current) {
        cityRef.current.focus();
      } else if (event.target === cityRef.current) {
        pinCodeRef.current.focus();
      } else if (event.target === pinCodeRef.current) {
        areaNameRef.current.focus();
      }else if (event.target === areaNameRef.current) {
        areaAbrvRef.current.focus();
      } else {
        areaAbrvRef.current.focus();
      }
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleSave = async () => {

    let hasError = false;

  if (!formData.PinCode) {
    toast.error('Pincode is required');
    setError(prev => ({ ...prev, PinCode: true }));
    hasError = true;
  } else {
    setError(prev => ({ ...prev, PinCode: false }));
  }

  if (!formData.AreaName) {
    toast.error('Area name is required');
    setError(prev => ({ ...prev, AreaName: true }));
    hasError = true;
  } else {
    setError(prev => ({ ...prev, AreaName: false }));
  }

  if (!formData.CityName) {
    toast.error('City is required');
    setError(prev => ({ ...prev, CityName: true }));
    hasError = true;
  } else {
    setError(prev => ({ ...prev, CityName: false }));
  }

  

  if (hasError) {
    return;
  }


    try {
      const payload = {
        PinCode: formData.PinCode,
        AreaName: formData.AreaName,
        CityID: parseInt(formData.CityName),
        AreaAbrv: formData.AreaAbrv,
        StateId: parseInt(formData.StateName),
        status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.PinId = currentPinId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch('pincodeMst/UpdatepincodeMst', payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post('pincodeMst/InsertpincodeMst', payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedPinId(response.data.Data)
          await fetchPincodeData(response.data.Data);
          setMode('view');
          setIsFormDisabled(true);
          setCurrentPinId(response.data.Data);
        } else {
          await UnLock(currentPinId, "MstPincode", "PinId");
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating pincode:', error);
      toast.error('Error saving/updating pincode. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentPinId, "MstPincode", "PinId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      PinCode: '',
      AreaName: '',
      CityName: '',
      AreaAbrv: '',
      StateName: ''
    });
    setCurrentPinId(null);

    setTimeout(() => {
      stateRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchPincodeData(1, "L");
      await UnLock(currentPinId, "MstPincode", "PinId");
      setStatus("1");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const handleExit = () => {
    navigate('/pincodetable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentPinId, "MstPincode", "PinId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchPincodeData(currentPinId, "D");
        await fetchPincodeData(currentPinId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>

      <Box className="form-container" sx= {{ height: { xs:'700px', sm: '550px' } }}>

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' 
            sx={{ display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between', 
                  marginTop: '20px',
                  flexDirection: { xs: 'column', sm: 'row', md: 'row' }   
              }}
              >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentPinId || currentPinId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentPinId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            
            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Pincode Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Pincode Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious} 
                onNext={handleNext} 
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} md={6} lg={3} className='form_field'>
            <CustomAutocomplete
              options={states}
              id="StateName-autocomplete"
              name='StateName'
              label="State"
              value={states.find(StateName => StateName.Id == formData.StateName) || null}
              onChange={handleInputChange}
              disabled={isFormDisabled}
              error={error.StateName}
              helperText={error.StateName ? '' : ''}
              ref={stateRef}
              onKeyDown={handleKeyPress}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3} className='form_field'>
            <CustomAutocomplete
              id="CityName-autocomplete"
              name='CityName'
              label="Select City"
              options={cities}
              value={cities.find(CityName => CityName.Id == formData.CityName) || null}
              onChange={handleInputChange}
              disabled={isFormDisabled}
              error={error.CityName}
              helperText={error.CityName ? '' : ''}
              ref={cityRef}
              onKeyDown={handleKeyPress}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6} className='form_field'>
            <TextField
              id="PinCode"
              name="PinCode"
              label={
                <span>
                  Pincode <span style={{ color: 'red' }}>*</span>
                </span>
               }
              variant="filled"
              fullWidth
              className="custom-textfield"
              value={formData.PinCode}
              onChange={handleInputChange}
              disabled={isFormDisabled}
              error={error.PinCode}
              helperText={error.PinCode ? '' : ''}
              inputRef={pinCodeRef}
              onKeyDown={handleKeyPress}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6} className='form_field'>
            <TextField
              id="AreaName"
              name="AreaName"
              label="Area"
              variant="filled"
              fullWidth
              className="custom-textfield"
              value={formData.AreaName}
              onChange={handleInputChange}
              disabled={isFormDisabled}
              error={error.AreaName}
              helperText={error.AreaName ? '' : ''}
              inputRef={areaNameRef}
              onKeyDown={handleKeyPress}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4} className='form_field'>
            <TextField
              id="AreaAbrv"
              name="AreaAbrv"
              label="Area Abrv"
              variant="filled"
              fullWidth
              className="custom-textfield"
              value={formData.AreaAbrv}
              onChange={handleInputChange}
              disabled={isFormDisabled}
              inputRef={areaAbrvRef}
              onKeyDown={handleKeyPress}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2} >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #d4d4d4)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave} >
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
            columns={columns}
            rows={rows}
            title="Pincode Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Pincode